// Display types
export const PIKKO_JACKPOT_DISPLAY_TYPE = {
  CONVERSION: 'conversion',
  REMINDER: 'reminder',
  LAST_CHANCE: 'last_chance',
  HAS_NEW_APP_CREDITED: 'has_app_new_credit',
  HAS_APP_EXISTING: 'has_app_existing',
  NONE: 'none',
  USED: 'used',
};

export const PIKKO_JACKPOT_TARGET = 5;

export const PIKKO_JACKPOT_ELIGIBLE_DISPLAY_TYPES = [
  PIKKO_JACKPOT_DISPLAY_TYPE.CONVERSION,
  PIKKO_JACKPOT_DISPLAY_TYPE.REMINDER,
  PIKKO_JACKPOT_DISPLAY_TYPE.LAST_CHANCE,
];

// Offer status action types
export const PIKKO_JACKPOT_OFFER_STATUS_REQUEST = 'PIKKO_JACKPOT_OFFER_STATUS_REQUEST';
export const PIKKO_JACKPOT_OFFER_STATUS_SUCCESS = 'PIKKO_JACKPOT_OFFER_STATUS_SUCCESS';
export const PIKKO_JACKPOT_OFFER_STATUS_FAIL = 'PIKKO_JACKPOT_OFFER_STATUS_FAIL';

// Reactivation action types
export const PIKKO_JACKPOT_REACTIVATE_REQUEST = 'PIKKO_JACKPOT_REACTIVATE_REQUEST';
export const PIKKO_JACKPOT_REACTIVATE_SUCCESS = 'PIKKO_JACKPOT_REACTIVATE_SUCCESS';
export const PIKKO_JACKPOT_REACTIVATE_FAIL = 'PIKKO_JACKPOT_REACTIVATE_FAIL';

// Reset
export const PIKKO_JACKPOT_RESET = 'PIKKO_JACKPOT_RESET';
